import { useState } from "react";
import { CircleChart } from "./CircleChart";
import NodeCarousal from "./NodeCarousal";
import { Grid } from "@mui/material";

import imgUrl from "../../assets/images/imgUrl";

export const chartNodes = [
  {
    id: "workflow",
    label: "Workflow based monitoring",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage4,
    card: {
      title: "Workflow based monitoring",
      description:
        "Enhancing early detection and response through a unified surveillance system.",
      image: imgUrl.circleImage4,
    },
  },
  {
    id: "infrastructure",
    label: "Infrastructure",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage1,
    card: {
      title: "Infrastructure",
      description:
        "Through solarisation and Starlink connectivity, we provide resilient, low-carbon digital infrastructure that ensures reliable power and internet access—critical for enabling digital transformation in fragile and low-resource settings.",
      image: imgUrl.circleImage1,
    },
  },
  {
    id: "openLMIS",
    label: "OpenLMIS",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage2,
    card: {
      title: "OpenLMIS",
      description:
        "Our OpenLMIS platform integrates with national health systems to improve supply chain efficiency and accountability, using AI and advanced analytics to forecast demand, prevent stock-outs, and ensure the availability of essential health products.",
      image: imgUrl.circleImage2,
    },
  },
  {
    id: "unitised-digital-transformation",
    label: "Unitised Digital Transformation",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage3,
    card: {
      title: "Unitised Digital Transformation",
      description:
        "Our Unitised Digital Transformation package delivers an end-to-end health system solution integrating data systems, infrastructure, and local capacity-building into a unified service for stronger, more resilient healthcare.",
      image: imgUrl.circleImage3,
    },
  },
  {
    id: "ai-as-practice",
    label: "AI as Practice",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage5,
    card: {
      title: "AI as Practice",
      description:
        "Dure’s AI practice, powered by Vita FI, uses generative, precision, and multimodal AI with real-time data to deliver personalized healthcare solutions, from obesity and diabetes management to intelligent chatbots and registries, empowering ministries and providers with sovereign, data-driven care at scale.",
      // "Next-generation monitoring and security infrastructure.",
      image: imgUrl.circleImage5,
    },
  },
  {
    id: "case-based-survaillaince",
    label: "Case Based Survaillaince",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage6,
    card: {
      title: "Case Based Survaillaince",
      description:
        "Our Monitoring and Evaluation tools provide real-time, case-based dashboards that track patients across the continuum of care, ensuring accountability, better outcomes, and system-wide efficiency through multi-channel, offline-capable, and country-owned platforms.",
      image: imgUrl.circleImage6,
    },
  },
  {
    id: "climate-and-health",
    label: "Climate and Health",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage7,
    card: {
      title: "Climate and Health",
      description:
        "Our Climate and Health solutions use predictive AI, global and community data, and real-time dashboards to help health systems manage climate risks, strengthen resilience, and plan effective adaptation strategies.",
      image: imgUrl.circleImage7,
    },
  },
  {
    id: "community-led-monitoring",
    label: "Community led Monitoring",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage8,
    card: {
      title: "Community led Monitoring",
      description:
        "Our Community-Led Monitoring tools, including OneImpact with over 1 million community members worldwide, empower people affected by TB, HIV, MPOX, and other health challenges to share real-time data, drive accountability, and strengthen national responses through inclusive, evidence-based dialogue.",
      image: imgUrl.circleImage8,
    },
  },
  {
    id: "situation-room",
    label: "Situation Room",
    mediaType: "image",
    mediaSrc: imgUrl.circleImage9,
    card: {
      title: "Situation Room",
      description:
        "The Real-Time Situation Room is a centralized data and analytics hub that unifies diverse systems into one warehouse, enabling advanced AI-powered dashboards, predictive modeling, and WhatsApp chatbots for timely, evidence-based decision-making.",
      image: imgUrl.circleImage8,
    },
  },
];

export const CircleChartWithCarousel = () => {
  const [activeNodeId, setActiveNodeId] = useState(chartNodes[0].id);

  const activeNode =
    chartNodes.find((node) => node.id === activeNodeId) || chartNodes[0];
  const currentIndex = chartNodes.findIndex((node) => node.id === activeNodeId);

  const handleNodeSelect = (node) => {
    setActiveNodeId(node.id);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % chartNodes.length;
    setActiveNodeId(chartNodes[nextIndex].id);
  };

  const handlePrev = () => {
    const prevIndex =
      (currentIndex - 1 + chartNodes.length) % chartNodes.length;
    setActiveNodeId(chartNodes[prevIndex].id);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <div className="circle-chart-container">
          <CircleChart
            activeNodeId={activeNodeId}
            onNodeSelect={handleNodeSelect}
            nodes={chartNodes}
          />
        </div>
      </Grid>
      <Grid
        size={{ xs: 12, lg: 6 }}
        className="d-flex-justify-content-align-item-center"
      >
        <div className="card-container">
          <NodeCarousal
            chartNodes={chartNodes}
            activeNode={activeNode}
            onNext={handleNext}
            onPrev={handlePrev}
          />
        </div>
      </Grid>
    </Grid>
  );
};
